import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900 font-body">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CardsSection />
        <MediaSection />
        <FAQSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <TopicsSection />
        <UpdatesSection />
        <AppSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}